// extracted by mini-css-extract-plugin
export default {"transactions":"styles_transactions__0RkSf","header":"styles_header__yp-8J","title":"styles_title__53Lo8","tabs":"styles_tabs__Bem4H","active":"styles_active__hzKAO"};